import { React, useState } from "react";
import { Link } from "react-router-dom";
import "./LandingPageHeader.css";
import { Button, Modal } from "antd";
import metropolisLogo from "../../../assets/images/logos/logo-metropolis.svg";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import { SignInContent } from "../../../containers/LandingPageContainers/SignInContent/SignInContent";


export const LandingPageHeader = () => {
    const [signIn, setSignIn] = useState(false);

    const handleSignInClose = () => {
        setSignIn(false);
    };

    const SignInModal = () => {
        return (

            <Modal
                centered
                title="Sign in Modal"
                open={signIn}
                wrapClassName="mtp-modal"
                closeIcon={SVGicon.mtpIconClose}
                onCancel={handleSignInClose}
                width={400}
                footer={""}
            >
                <SignInContent />
            </Modal>
        )
    }

    return (
        <>
            <header>
                <div className="landing-subHeader-top">
                    <div className="mtp-container-fluid">
                        <div className="landing-subHeader-menubar">
                            <Link className="fw-400 landing-subHeader-link" type="prime-outlined" onClick={() => setSignIn(true)}>
                                Sign in
                            </Link>
                            <Link to="/" className="landing-subHeader-link fw-400">
                                Support
                            </Link>
                            <Link to="/" className="landing-subHeader-link fw-400">
                                Contact Sales
                            </Link>
                            <Button className="flex-center" shape="circle" icon={SVGicon.mtpIconSearch} />
                        </div>
                    </div>
                </div>
                <div className="landing-mainHeader">
                    <div className="mtp-container-fluid">
                        <div className="landing-header-wrap">
                            <div className="logo-wrap ">
                                <Link to="/" className="landing-header-logo flex-center flex-center-auto-0 contain-image ">
                                    <img src={metropolisLogo} alt="header-logo" />
                                </Link>
                            </div>
                            <div className="menu-wrap">
                                <Link to="/" className="landing-header-link fw-400">
                                    Why Metropolis?
                                </Link>
                                <Link to="/FAQ " className="landing-header-link fw-400">
                                    FAQ's
                                </Link>
                                <Link to="/CalculatorROI " className="landing-header-link fw-400">
                                    ROI Calculator
                                </Link>
                                <Link to="/contact" className="landing-header-link fw-400">
                                    Contact Us
                                </Link>
                                <Link to="/signup" className="landing-header-link fw-400">
                                    Sign Up
                                </Link>
                                <Button className="CustomButton landing-header-btn" type="prime-outlined" > Free Employer Account </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <SignInModal />
        </>
    );
};
